import React from 'react';
import { useTranslation } from 'react-i18next';
import { getScoreColorClass } from 'utils/scoreColors';
import ScoreInfoButton from '../ScoreInfoButton/ScoreInfoButton';

const ScoreMetricDisplay = ({ seoScore, uxScore }) => {
  const { t } = useTranslation();

  return (
    <div className="score-metrics-display">
      <div className="metric">
        <span className="metric-label">
          {t('Score SEO')}
          <ScoreInfoButton
            text={t('scoreTooltip.seo')}
            onClick={(e) => e.stopPropagation()}
          />
        </span>
        <span className={`metric-value  ${getScoreColorClass(seoScore)}`}>
          {seoScore}%
        </span>
      </div>
      <div className="metric">
        <span className="metric-label">
          {t('Score UX')}
          <ScoreInfoButton
            text={t('scoreTooltip.ux')}
            onClick={(e) => e.stopPropagation()}
          />
        </span>
        <span className={`metric-value  ${getScoreColorClass(uxScore)}`}>
          {uxScore}%
        </span>
      </div>
    </div>
  );
};

export default ScoreMetricDisplay;
